export const AUTH = {
    post: {
        login: {
            path: 'auth/login'
        },

    },
};
